// Sample Conversion Data
export const sampleConversions = [
    {
        id: 1,
        leadNo: '514569',
        name: 'Vivian Hettinger',
        companyName: '',
        mobile: '+91-9743574501',
        email: 'shea.crona@hotmail.com',
        totalBusiness: 50000,
        totalOrders: 1,
        lastOrderDate: '22-Dec-2025',
        city: '',
        state: '',
        followupStatus: 'Converted',
        orderDate: '22-Dec-2025 17:06',
        remarks: 'fsdfsd',
        products: '',
        amountPaid: 50000,
        assignedTo: 'training training'
    },
    {
        id: 2,
        leadNo: '524511',
        name: '',
        companyName: '',
        mobile: '+917011628314',
        email: '',
        totalBusiness: 50000,
        totalOrders: 1,
        lastOrderDate: '',
        city: '',
        state: '',
        followupStatus: 'Converted',
        orderDate: '',
        remarks: '-0',
        products: '',
        amountPaid: 50000,
        assignedTo: ''
    },
    {
        id: 3,
        leadNo: '515577',
        name: '',
        companyName: '',
        mobile: '+919250681053',
        email: '',
        totalBusiness: 10000,
        totalOrders: 1,
        lastOrderDate: '',
        city: '',
        state: '',
        followupStatus: 'Converted',
        orderDate: '',
        remarks: '-0',
        products: '',
        amountPaid: 10000,
        assignedTo: ''
    },
    {
        id: 4,
        leadNo: '502519',
        name: 'Shubham kit19',
        companyName: '',
        mobile: '+91-8487789966',
        email: 'engg',
        totalBusiness: 200,
        totalOrders: 1,
        lastOrderDate: '',
        city: '',
        state: '',
        followupStatus: 'Converted',
        orderDate: '',
        remarks: '',
        products: '',
        amountPaid: 200,
        assignedTo: ''
    },
    {
        id: 5,
        leadNo: '328736',
        name: 'Mr. Patel',
        companyName: '',
        mobile: '+91-9429512136',
        email: '',
        totalBusiness: 200000,
        totalOrders: 1,
        lastOrderDate: '',
        city: '',
        state: '',
        followupStatus: 'Converted',
        orderDate: '',
        remarks: '',
        products: '',
        amountPaid: 200000,
        assignedTo: ''
    },
    {
        id: 6,
        leadNo: '333951',
        name: 'Karan',
        companyName: '',
        mobile: '+91-9811134200',
        email: '',
        totalBusiness: 40000,
        totalOrders: 1,
        lastOrderDate: '',
        city: '',
        state: '',
        followupStatus: 'Converted',
        orderDate: '',
        remarks: '',
        products: '',
        amountPaid: 40000,
        assignedTo: ''
    },
    {
        id: 7,
        leadNo: '306493',
        name: '917017061154',
        companyName: '',
        mobile: '+91-7017061154',
        email: '',
        totalBusiness: 500000,
        totalOrders: 1,
        lastOrderDate: '',
        city: '',
        state: '',
        followupStatus: 'Converted',
        orderDate: '',
        remarks: '',
        products: '',
        amountPaid: 500000,
        assignedTo: ''
    },
    {
        id: 8,
        leadNo: '124228',
        name: 'Abdur Rahman Khan',
        companyName: '',
        mobile: '+91-7428494941',
        email: 'resosi7353@owube.com',
        totalBusiness: 43,
        totalOrders: 1,
        lastOrderDate: '',
        city: '',
        state: '',
        followupStatus: 'Converted',
        orderDate: '',
        remarks: '',
        products: '',
        amountPaid: 43,
        assignedTo: ''
    },
    {
        id: 9,
        leadNo: '281918',
        name: '919582158073',
        companyName: '',
        mobile: '+91-9582158073',
        email: '',
        totalBusiness: 0,
        totalOrders: 1,
        lastOrderDate: '',
        city: '',
        state: '',
        followupStatus: 'Converted',
        orderDate: '',
        remarks: '',
        products: '',
        amountPaid: 0,
        assignedTo: ''
    },
    {
        id: 10,
        leadNo: '281919',
        name: 'Test User',
        companyName: 'ABC Corp',
        mobile: '+91-9876543210',
        email: 'test@example.com',
        totalBusiness: 75000,
        totalOrders: 2,
        lastOrderDate: '15-Jan-2026',
        city: 'Mumbai',
        state: 'Maharashtra',
        followupStatus: 'Converted',
        orderDate: '15-Jan-2026 14:30',
        remarks: 'Premium customer',
        products: 'Product A, Product B',
        amountPaid: 75000,
        assignedTo: 'Sales Team'
    }
];

// Table Column Configuration
export const tableColumns = [
    { key: 'leadNo', label: 'Lead No', sortable: true },
    { key: 'name', label: 'Name', sortable: true },
    { key: 'companyName', label: 'Company Name', sortable: false },
    { key: 'mobile', label: 'Mobile', sortable: false },
    { key: 'email', label: 'Email', sortable: false },
    { key: 'totalBusiness', label: 'Total Business', sortable: true },
    { key: 'totalOrders', label: 'Total Orders', sortable: true },
    { key: 'lastOrderDate', label: 'Last Order Date', sortable: true },
    { key: 'city', label: 'City', sortable: true },
    { key: 'state', label: 'State', sortable: true },
];

// Conversion Types
export const conversionTypes = {
    CONSOLIDATED: 'consolidated',
    INDIVIDUAL: 'individual'
};

// Export options
export const exportFormats = ['CSV', 'Excel', 'PDF'];
